import { LoggedInUserInfo } from '@commenda/types/src/user';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export function useLoggedInUser(
  filter?: { includeCalComDetails?: boolean },
  options?: { enabled?: boolean }
) {
  const queryParams = new URLSearchParams();

  if (filter?.includeCalComDetails) {
    queryParams.append('includeCalDetails', 'true');
  }

  const isEnabled = options?.enabled ?? true;

  const {
    data,
    error,
    mutate,
  }: {
    data?: LoggedInUserInfo;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    isEnabled ? `user/me?${queryParams}` : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
